var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15,
    fill: "#EDEDED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Product detail Page",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2847,
    transform: "translate(-1023 -380)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow",
    d: "M1 7.5H14M9 1.5L14.2929 6.79289C14.6834 7.18342 14.6834 7.81658 14.2929 8.20711L9 13.5",
    stroke: "#807D7E",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2847,
    fill: "white",
    transform: "translate(-1023 -380)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.012252063e60e5ff1fd151dfa049fc4c.svg";
export { ForwardRef as ReactComponent };